import React from 'react';

export function WhyUsSection() {
  return (
    <section id="s-why-us" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-why-us" data-reveal>
          <div className="franchise-why-us__background">Фон</div>
          <div className="franchise-why-us__banner">ПОЧЕМУ ВЫБИРАЮТ SUSHIBOX</div>
          <div className="franchise-why-us__body">
            <div className="franchise-why-us__body__container">
              <div>
                <div className="franchise-why-us__body__container__num">
                  1
                </div>
                <div className="franchise-why-us__body__container__text">
                  Сильный маркетинг
                </div>
              </div>
              <div>
                <img src="/assets/media/franchise/why-us-section/icon-1.svg" alt="icon" />
              </div>
            </div>
            <div className="franchise-why-us__body__container">
              <div>
                <div className="franchise-why-us__body__container__num">
                  2
                </div>
                <div className="franchise-why-us__body__container__text">
                  Проверенная модель
                </div>
              </div>
              <div>
                <img src="/assets/media/franchise/why-us-section/icon-2.svg" alt="icon" />
              </div>
            </div>
            <div className="franchise-why-us__body__container">
              <div>
                <div className="franchise-why-us__body__container__num">
                  3
                </div>
                <div className="franchise-why-us__body__container__text">
                  Цифровая экосистема
                </div>
              </div>
              <div>
                <img style={{ transform: 'translate(0px, 25px)' }} src="/assets/media/franchise/why-us-section/icon-3-laptop.svg" alt="icon" />
                <img style={{ position: 'absolute', transform: 'translate(35px, -20px)' }} src="/assets/media/franchise/why-us-section/icon-3-phone.svg" alt="icon" />
              </div>
            </div>
            <div className="franchise-why-us__body__container">
              <div>
                <div className="franchise-why-us__body__container__num">
                  4
                </div>
                <div className="franchise-why-us__body__container__text">
                  Открытая кухня
                </div>
              </div>
              <div>
                <img src="/assets/media/franchise/why-us-section/icon-4.svg" alt="icon" />
              </div>
            </div>
            <div className="franchise-why-us__body__container">
              <div>
                <div className="franchise-why-us__body__container__num">
                  5
                </div>
                <div className="franchise-why-us__body__container__text">
                  Поддержка команды
                </div>
              </div>
              <div>
                <img src="/assets/media/franchise/why-us-section/icon-5.svg" alt="icon" />
              </div>
            </div>
          </div>
          <img className="franchise-why-us__box-image" src="/assets/media/franchise/why-us-section/hand-with-box.png" alt="Коробка" />
          <img className="franchise-why-us__fish" src="/assets/media/franchise/map-section/fish.svg" alt="Рыбки" />
        </div>
      </div>
    </section>
  );
}
